// Meta Pixel (Facebook Pixel): helper único de tracking.
// Nada de fbq() suelto en componentes; todo evento pasa por aquí.
//
// PRIVACIDAD (Daisies es categoría de salud para Meta): NUNCA enviar como
// parámetro datos clínicos ni PII en claro: especialidad, síntoma,
// diagnóstico, nombre o email. Solo monto, moneda, nombre de plan e
// identificadores no sensibles. Si Meta detecta datos de salud bloquea
// los eventos de toda la cuenta.

const PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID || '';

// Carga el script base una sola vez (fbevents.js + init + PageView inicial).
// Aislado aquí para condicionarlo a un banner de cookies cuando exista.
export const initPixel = () => {
  if (typeof window === 'undefined' || !PIXEL_ID) return;
  if (window.fbq) return; // evita doble carga del script

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
};

// fbevents encola llamadas hechas antes de que el script remoto termine de
// cargar, no se pierden eventos.
const call = (...args) => {
  if (typeof window === 'undefined' || !PIXEL_ID || !window.fbq) return;
  window.fbq(...args);
};

export const pixelPageView = () => call('track', 'PageView');
export const pixelLead = () => call('track', 'Lead');
export const pixelCompleteRegistration = () => call('track', 'CompleteRegistration');
export const pixelSchedule = () => call('track', 'Schedule');
export const pixelInitiateCheckout = () => call('track', 'InitiateCheckout');

// uuid v4 para deduplicar contra la Conversions API cuando Odoo mande el
// mismo Purchase server-side (mismo eventID en ambos lados).
export const generateEventId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const pixelPurchase = ({ value, currency = 'MXN', plan, eventId }) =>
  call(
    'track',
    'Purchase',
    { value, currency, content_name: plan },
    { eventID: eventId || generateEventId() }
  );
